<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <el-form label-width="70px">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="买手店">
                <BrandSelect :data="vendorList" v-model="queryForm.vendorId" key="query-vendor" clearable filterable></BrandSelect>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
              <el-form-item label="IM品牌">
                <BrandSelect :data="brandList" v-model="queryForm.brandId" key="query-brand" clearable filterable></BrandSelect>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-button @click="search" type="primary">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    
    <div class="toolbar">
      <el-button type="primary" @click="showForm">新增Mapping</el-button>
    </div>

    <el-table :data="tableData">
      <el-table-column prop="vendorName" label="买手店"></el-table-column>
      <el-table-column prop="imbrandName" label="IM品牌"></el-table-column>
      <el-table-column prop="boutiqueBrandName" label="买手店品牌"></el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="removeItem(scope.row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="新增Mapping" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form label-width="140px">
        <el-form-item label="买手店">
          <BrandSelect :data="vendorList" v-model="ruleForm.vendorId" key="form-vendor" clearable filterable></BrandSelect>
        </el-form-item>
        <el-form-item label="IM品牌">
          <BrandSelect :data="brandList" v-model="ruleForm.brandId" key="form-brand" clearable filterable></BrandSelect>
        </el-form-item>
        <el-form-item label="买手店品牌">
          <el-input v-model="ruleForm.boutiqueBrandName" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMappingVendorList,
  getVendorBrandList,
  getVendorBrandMappingList,
  addVendorBrandMapping,
  delVendorBrandMapping,
} from '../../api/mapping';
import BrandSelect from '../shared/brandSelect.vue';

export default {
  components: {
    BrandSelect,
  },
  data() {
    return {
      fullscreenLoading: false,
      vendorList: [],
      brandList: [],
      daterange: [],
      queryForm: {
        vendorId: null,
        brandId: null,
        pageNo: 1,
        pageSize: 25,
      },
      tableData: [],
      total: 0,
      dialogVisible: false,
      ruleForm: {
        vendorId: null,
        brandId: null,
        boutiqueBrandName: '',
      },
    };
  },
  created() {
    getMappingVendorList().then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data.map((item) => ({
          value: item.vendorId,
          label: item.vendorName,
        }));
      }
    });
    getVendorBrandList().then(res => {
      if (res.data && res.data.data) {
        this.brandList = res.data.data.map((item) => ({
          value: item.brandId,
          label: item.brandName,
        }));
      }
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.pageNo = 1;
      this.daterange = [];
      this.getTableData();
    },
    getTableData() {
      getVendorBrandMappingList({
        ...this.queryForm,
        startTime: this.daterange && this.daterange[0] || 0,
        endTime: this.daterange && this.daterange[1] || 0,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.records;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    removeItem(row) {
      this.$confirm(`确认删除${row.vendorName}-${row.boutiqueBrandName}吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delVendorBrandMapping({
          id: row.id,
        }).then((res) => {
          if (res.data && res.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常，请稍后再试');
          }
        })
      }).catch(() => {});
    },
    showForm() {
      this.ruleForm.vendorId = null;
      this.ruleForm.brandId = null;
      this.ruleForm.boutiqueBrandName = null;
      this.dialogVisible = true;
    },
    async submit() {
      if (!this.ruleForm.vendorId) {
        this.$message.error('请选择买手店');
        return;
      }
      if (!this.ruleForm.brandId) {
        this.$message.error('请选择IM品牌');
        return;
      }
      if (!this.ruleForm.boutiqueBrandName) {
        this.$message.error('请输入买手店品牌');
        return;
      }
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      addVendorBrandMapping(this.ruleForm).then((res) => {
        if (res.data && res.data.success) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '系统异常，请稍后再试');
        }
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 1000);
      }).catch(() => {
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 1000);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.red {
  color: red;
}
.ml10 {
  margin-left: 10px;
}
.mt20 {
  margin-top: 20px;
}
</style>
